<div class="container">
  <h2>{{ 'workWithUs.title' | cxTranslate }}</h2>
  <div class="d-flex flex-wrap justify-content-center">
    <form #frm [formGroup]="workWithUsForm" (submit)="submitForm()" class="row w-75">
      <div class="col-md-12">
        <p class="subtitle">{{ 'workWithUs.subtitle' | cxTranslate }}</p>
      </div>
      <div class="form-group col-md-6">
        <label>
          <span class="label-content mandatory">{{ 'workWithUs.name' | cxTranslate }}</span>
          <input class="form-control" type="text" formControlName="fullName" />
          <cx-form-errors [control]="workWithUsForm.get('fullName')"></cx-form-errors>
        </label>
      </div>
      <div class="form-group col-md-6">
        <label>
          <span class="label-content mandatory">{{ 'workWithUs.email' | cxTranslate }}</span>
          <input class="form-control" type="text" formControlName="email" />
          <cx-form-errors [control]="workWithUsForm.get('email')"></cx-form-errors>
        </label>
      </div>
      <div class="form-group col-md-6">
        <label class="select-label">
          <span class="label-content mandatory">{{ 'register.region' | cxTranslate }}</span>

          <select id="originalSelect" formControlName="region" class="form-control">
            <option selected value="">
              {{ 'workWithUs.province' | cxTranslate }}
            </option>
            @for (region of regions$ | async; track region) {
              <option class="option-select" [value]="region.isocode">
                {{ region.name }}
              </option>
            }
          </select>
          <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>

          <cx-form-errors id="control-errors" class="control-errors" [control]="workWithUsForm.get('region')"> </cx-form-errors>
        </label>
      </div>
      <div class="form-group col-md-6">
        <label>
          <span class="label-content mandatory">{{ 'workWithUs.phone' | cxTranslate }}</span>
          <input class="form-control" type="text" formControlName="phone" />
          <cx-form-errors [control]="workWithUsForm.get('phone')"></cx-form-errors>
        </label>
      </div>
      <div class="form-group col-md-12">
        <app-custom-file-uploader [label]="'forms.workWithUs.addCV' | cxTranslate" [formGroup]="workWithUsForm" [required]="true" [maxFileSize]="5120"> </app-custom-file-uploader>
      </div>
      <div class="col-md-12">
        <p class="info-text info-text-bottom">
          <span [innerHTML]="'forms.workWithUs.basicInfoPrivacy' | cxTranslate"></span>
          <a class="link-terms" [routerLink]="{ cxRoute: 'termsAndConditions' } | cxUrl" documentType="_blank">{{ 'contactUs.privacyTerms' | cxTranslate }}</a>
        </p>
      </div>
      <div class="form-group col-md-5">
        <div class="form-check keep-in-session">
          <label class="checkbox">
            <input type="checkbox" formControlName="privacyPolicy" />
            <span class="form-check-label info-text mandatory">
              <span [innerHTML]="'forms.contactUs.termsAndConditions' | cxTranslate"></span>
              <a [routerLink]="{ cxRoute: 'termsAndConditions' } | cxUrl" documentType="_blank">
                {{ 'contactUs.termsAndConditions2' | cxTranslate }}
              </a>
            </span>
          </label>
        </div>
        <cx-form-errors [control]="workWithUsForm.get('privacyPolicy')"></cx-form-errors>
      </div>
      <div class="form-group col-md-5">
        <div class="form-check keep-in-session">
          <label class="checkbox">
            <input type="checkbox" formControlName="authorizePersonalData" />
            <span class="form-check-label info-text mandatory">
              {{ 'workWithUs.dataCheck' | cxTranslate }}
            </span>
          </label>
        </div>
        <cx-form-errors [control]="workWithUsForm.get('authorizePersonalData')"></cx-form-errors>
      </div>
      <div class="row col-md-12 m-0 btn-margin">
        <button class="btn btn-block btn-black col-md-5" type="submit" [disabled]="submitted$ | async">
          {{ 'workWithUs.send' | cxTranslate }}
        </button>
      </div>
    </form>
  </div>
</div>
